import React from "react";
import { Link } from "react-router-dom";

const cols = [
  { title: "Learn", links: [ ["Framework Library", "/library"], ["Risk Glossary", "/glossary"], ["USA Regulatory Hub", "/usa"], ["Pulse — risk intel", "/pulse"] ] },
  { title: "Do", links: [ ["Money Flow map", "/money-flow"], ["Workflow Automations", "/automations"], ["GRC Maturity Scorer", "/tools/grc-maturity"], ["All tools", "/tools"] ] },
  { title: "Regulators", links: [ ["SEC", "/usa/sec"], ["Federal Banking Agencies", "/usa/federal-reserve"], ["CISA", "/usa/cisa"], ["FinCEN", "/usa/fincen"], ["NYDFS Part 500", "/usa/nydfs"] ] },
  { title: "Company", links: [ ["Get started", "/signup"], ["Log in", "/login"], ["Admin console", "/admin"], ["Suggest a framework", "/library"] ] }
];

export default function Footer() {
  return (
    <footer className="bg-[#14130F] text-white/70 mt-0" data-testid="footer">
      <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-[#3F4CE0]" />
              <span className="font-display font-bold text-[19px] text-white">RiskPedia <span className="text-[#8B94F5]">USA</span></span>
            </Link>
            <p className="mt-4 text-[13px] leading-relaxed text-white/50">The risk framework encyclopedia & AI advisor for American risk professionals, auditors and local-government leaders.</p>
            <p className="mt-4 font-mono-label text-[10px] text-white/35">73+ frameworks · 6 regulators · 212+ terms</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-mono-label text-[11px] text-white/40 mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-[13.5px] text-white/65 hover:text-white rp-btn">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="text-[12px] text-white/40">© 2025 RiskPedia USA. Educational content — not legal, investment or audit advice.</p>
          <p className="text-[11px] text-white/30 max-w-lg">Money-flow figures are AI-curated, unaudited estimates for educational purposes only. Verify against USAspending.gov, CBO and official state ACFRs.</p>
        </div>
      </div>
    </footer>
  );
}
